'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'browser';
var width = 512;
var height = 512;
var aliases = [128468];
var unicode = 'f37e';
var svgPathData = ['M32 192l448 0 0 192c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32l0-192z', 'M160 96l0 64 320 0 0-32c0-17.7-14.3-32-32-32L160 96zm-32 0L64 96c-17.7 0-32 14.3-32 32l0 32 96 0 0-64zM32 192l0 192c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-192-448 0zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrowser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;